import React, { useState } from "react";
import { Container, Row, Col, Form, Card, Button } from "react-bootstrap";
import { Link } from "react-router-dom";
import Topnav from "../common/Topnav";
import Footer from "../common/Footer";
import Swal from "sweetalert2";
import faqBanner from "../../Images/student-services/ragging.webp";
import classroomImage from "../../Images/gov-body/rules.webp";
import axios from "axios";
import razorpay from "../../Images/companylogo/razorpayLogo.png";
import basispay from "../../Images/companylogo/basispayLogo.jpg";
// import * as bootstrap from "bootstrap";

const SCRIPT_URL =
  "https://script.google.com/macros/s/AKfycbxTTUpOC3dBd8qh1o4vs9A1-y3rpLRF5lHXuZf1KFlrDh5D40B_PYL-CtvO1ZpPL8ue/exec";

const VariousApplication = () => {
  // Applicant Details
  const [fullName, setFullName] = useState("");
  const [enrollmentNo, setEnrollmentNo] = useState("");
  const [course, setCourse] = useState("");
  const [applicationType, setApplicationType] = useState("");

  // Checkboxes
  const [lostDocument, setLostDocument] = useState(false);
  const [authorization, setAuthorization] = useState(false);
  const [declaration, setDeclaration] = useState(false);

  // Files
  const [duplicateFile, setDuplicateFile] = useState(null);
  const [idProof, setIdProof] = useState(null);
  const [oldDocument, setOldDocument] = useState(null);
  const [firCopy, setFirCopy] = useState(null);
  const [passportPhoto, setPassportPhoto] = useState(null);
  const [authorizationLetter, setAuthorizationLetter] = useState(null);
  const [representativeId, setRepresentativeId] = useState(null);
  const [provisionalCertificate, setProvisionalCertificate] = useState(null);
  const [latestMarksheet, setLatestMarksheet] = useState(null);
  const [allSemesterMarksheet, setAllSemesterMarksheet] = useState(null);
  const [finalSemesterMarksheet, setFinalSemesterMarksheet] = useState(null);
  const [provisionalCopy, setProvisionalCopy] = useState(null);

  const [loading, setLoading] = useState(false);
  const [pendingFormData, setPendingFormData] = useState(null);

  const getApplicationAmount = () => {
    switch (applicationType) {
      case "duplicate_marksheet":
        return 1000;

      case "migration_certificate":
        return 2000;

      case "provisional_degree":
        return 5000;

      default:
        return 0;
    }
  };

  const submitApplication = async (formData, paymentDetails) => {
    formData.append("paymentAmount", paymentDetails.amount);

    formData.append("paymentStatus", "SUCCESS");

    formData.append("paymentId", paymentDetails.paymentId);

    formData.append("orderId", paymentDetails.orderId);

    const response = await fetch(
      "https://isbmuniversity.edu.in/form-api/various-application-upload.php",
      {
        method: "POST",
        body: formData,
      },
    );

    return await response.json();
  };

  const handleRazorpay = async (formData) => {
    const amount = getApplicationAmount();

    try {
      const orderRes = await axios.post(
        "https://isbmuniversity.edu.in/api/create_order.php",
        {
          amount: amount * 100,
          currency: "INR",
        },
      );

      const { order_id } = orderRes.data;

      const options = {
        key: "rzp_live_bZvNUjzwu1aZE7",

        amount: amount * 100,

        currency: "INR",

        name: "ISBM University",

        description:
          applicationConfig[applicationType]?.title || "Various Application",

        order_id,

        prefill: {
          name: fullName,
        },

        notes: {
          enrollmentNo,

          course,

          applicationType,
        },

        theme: {
          color: "#004E9E",
        },

        handler: async function (response) {
          Swal.fire({
            title: "Verifying Payment...",
            allowOutsideClick: false,
            didOpen: () => Swal.showLoading(),
          });

          // STEP 1 : Save payment in payment table
          const saveRes = await axios.post(
            "https://isbmuniversity.edu.in/api/save_payment.php",
            {
              razorpay_payment_id: response.razorpay_payment_id,
              razorpay_order_id: response.razorpay_order_id,
              razorpay_signature: response.razorpay_signature,

              name: fullName,
              email: "NA",
              phone: "NA",
              amount: amount,

              // Save Course column
              course: course,

              // Save Comment column
              comment: `${enrollmentNo}*${applicationConfig[applicationType]?.title}`,
            },
          );

          if (!saveRes.data.success) {
            Swal.close();

            Swal.fire({
              icon: "error",
              title: "Payment Saved Failed",
            });

            return;
          }

          // STEP 2 : Upload application
          const result = await submitApplication(formData, {
            amount,
            paymentId: response.razorpay_payment_id,
            orderId: response.razorpay_order_id,
          });

          Swal.close();

          if (result.success) {
            await Swal.fire({
              icon: "success",
              title: "Payment Successful",
              text: "Application submitted successfully.",
            });

            // STEP 3 : Open receipt
            window.open(saveRes.data.redirect, "_blank");

            resetForm();
          } else {
            Swal.fire({
              icon: "error",
              title: "Application Upload Failed",
              text: result.message,
            });
          }
        },

        modal: {
          ondismiss: function () {
            setLoading(false);

            Swal.fire({
              icon: "warning",

              title: "Payment Cancelled",

              text: "Application has not been submitted.",
            });
          },
        },
      };

      const razor = new window.Razorpay(options);

      razor.on("payment.failed", function (response) {
        setLoading(false);

        Swal.fire({
          icon: "error",

          title: "Payment Failed",

          text: response.error.description,
        });
      });

      razor.open();
    } catch (err) {
      console.log(err);
      console.log(err.response);
      console.log(err.response?.data);

      Swal.fire({
        icon: "error",
        title: "Payment Error",
        text: err.response?.data?.message || err.message,
      });
    }
  };

  const handleBasisPay = async (formData) => {
    try {
      const amount = getApplicationAmount();

      const orderId = "APP" + new Date().getTime();

      const paymentData = {
        return_url: "https://isbmuniversity.edu.in/api/payment_response.php",

        mode: "LIVE",

        order_id: orderId,

        amount: amount,

        currency: "INR",

        description: applicationConfig[applicationType]?.title,

        name: fullName,

        email: "VariousApplicationNA@gmail.com", // If you have email field then pass it

        phone: "1234567890", // If you have phone field then pass it

        address_line_1: "",

        address_line_2: "",

        city: "NA",

        state: "NA",

        zip_code: "NA",

        country: "India",

        udf1: applicationType,

        udf2: enrollmentNo,

        udf3: "",

        udf4: "",

        udf5: "",
      };

      Swal.fire({
        title: "Redirecting to BasisPay...",
        allowOutsideClick: false,
        didOpen: () => Swal.showLoading(),
      });

      const hashResponse = await axios.post(
        "https://isbmuniversity.edu.in/api/payment_proceed.php",
        paymentData,
      );

      Swal.close();

      const hash = hashResponse.data.data;

      const form = document.createElement("form");

      form.method = "POST";

      form.action = "https://pay.basispay.in/v2/paymentrequest";

      const fields = {
        api_key: "51f1c2bf-8654-4215-8ee4-5bf4ef779955",
        hash: hash,
        ...paymentData,
      };

      Object.keys(fields).forEach((key) => {
        const input = document.createElement("input");

        input.type = "hidden";

        input.name = key;

        input.value = fields[key];

        form.appendChild(input);
      });

      document.body.appendChild(form);

      form.submit();
    } catch (error) {
      console.error(error);

      setLoading(false);

      Swal.fire({
        icon: "error",

        title: "BasisPay Error",

        text: "Unable to initiate payment.",
      });
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    setLoading(true);

    const formData = new FormData();

    formData.append("fullName", fullName);
    formData.append("enrollmentNo", enrollmentNo);
    formData.append("course", course);
    formData.append("applicationType", applicationType);

    formData.append("lostDocument", lostDocument ? 1 : 0);

    formData.append("authorization", authorization ? 1 : 0);

    formData.append("declaration", declaration ? 1 : 0);

    formData.append("idProof", idProof);
    formData.append("passportPhoto", passportPhoto);

    if (authorizationLetter)
      formData.append("authorizationLetter", authorizationLetter);

    if (representativeId) formData.append("representativeId", representativeId);

    switch (applicationType) {
      case "duplicate_marksheet":
        formData.append("duplicateApplication", duplicateFile);

        if (oldDocument) formData.append("oldMarksheet", oldDocument);

        if (firCopy) formData.append("firCopy", firCopy);

        break;

      case "migration_certificate":
        formData.append("migrationApplication", duplicateFile);

        if (oldDocument) formData.append("attestedMarksheet", oldDocument);

        if (provisionalCertificate)
          formData.append("provisionalCertificate", provisionalCertificate);

        if (latestMarksheet)
          formData.append("latestUniversityMarksheet", latestMarksheet);

        break;

      case "provisional_degree":
        formData.append("provisionalDegreeApplication", duplicateFile);

        if (oldDocument)
          formData.append("finalYearSemesterMarksheet", oldDocument);

        if (allSemesterMarksheet)
          formData.append("allSemesterMarksheets", allSemesterMarksheet);

        if (finalSemesterMarksheet)
          formData.append("finalSemesterMarksheet", finalSemesterMarksheet);

        if (provisionalCopy)
          formData.append("provisionalCertificateCopy", provisionalCopy);

        break;
    }

    const amount = getApplicationAmount();

    if (amount === 0) {
      setLoading(false);

      Swal.fire({
        icon: "warning",
        title: "Please select an application type.",
      });

      return;
    }

    setPendingFormData(formData);

    // new bootstrap.Modal(document.getElementById("paymentModal")).show();
    document.getElementById("paymentModalBtn").click();
  };

  //   const handleSubmit = async (e) => {
  //     setLoading(true);

  //     Swal.fire({
  //       title: "Submitting Application...",
  //       text: "Please wait while we upload your documents.",
  //       allowOutsideClick: false,
  //       allowEscapeKey: false,
  //       didOpen: () => {
  //         Swal.showLoading();
  //       },
  //     });

  //     e.preventDefault();

  //     try {
  //       const formData = new FormData();

  //       // Applicant Details
  //       formData.append("fullName", fullName);
  //       formData.append("enrollmentNo", enrollmentNo);
  //       formData.append("course", course);
  //       formData.append("applicationType", applicationType);

  //       // Checkboxes
  //       formData.append("lostDocument", lostDocument ? 1 : 0);
  //       formData.append("authorization", authorization ? 1 : 0);
  //       formData.append("declaration", declaration ? 1 : 0);

  //       // Files
  //       // Common Documents
  //       formData.append("idProof", idProof);
  //       formData.append("passportPhoto", passportPhoto);

  //       if (authorizationLetter)
  //         formData.append("authorizationLetter", authorizationLetter);

  //       if (representativeId)
  //         formData.append("representativeId", representativeId);

  //       // Application Specific Documents

  //       switch (applicationType) {
  //         case "duplicate_marksheet":
  //           formData.append("duplicateApplication", duplicateFile);

  //           if (oldDocument) formData.append("oldMarksheet", oldDocument);

  //           if (firCopy) formData.append("firCopy", firCopy);

  //           break;

  //         case "migration_certificate":
  //           formData.append("migrationApplication", duplicateFile);

  //           if (oldDocument) formData.append("attestedMarksheet", oldDocument);

  //           if (provisionalCertificate)
  //             formData.append("provisionalCertificate", provisionalCertificate);

  //           if (latestMarksheet)
  //             formData.append("latestUniversityMarksheet", latestMarksheet);

  //           break;

  //         case "provisional_degree":
  //           formData.append("provisionalDegreeApplication", duplicateFile);

  //           if (oldDocument)
  //             formData.append("finalYearSemesterMarksheet", oldDocument);

  //           if (allSemesterMarksheet)
  //             formData.append("allSemesterMarksheets", allSemesterMarksheet);

  //           if (finalSemesterMarksheet)
  //             formData.append("finalSemesterMarksheet", finalSemesterMarksheet);

  //           if (provisionalCopy)
  //             formData.append("provisionalCertificateCopy", provisionalCopy);

  //           break;
  //       }
  //       const response = await fetch(
  //         "https://isbmuniversity.edu.in/form-api/various-application-upload.php",
  //         {
  //           method: "POST",
  //           body: formData,
  //         },
  //       );

  //       const result = await response.json();

  //       Swal.close();

  //       if (result.success) {
  //         Swal.fire({
  //           icon: "success",
  //           title: "Application Submitted!",
  //           text: result.message,
  //           confirmButtonColor: "#004E9E",
  //         });

  //         resetForm();
  //       } else {
  //         Swal.fire({
  //           icon: "error",
  //           title: "Submission Failed",
  //           text: result.message,
  //           confirmButtonColor: "#dc3545",
  //         });
  //       }
  //     } catch (error) {
  //       console.error(error);

  //       Swal.close();

  //       Swal.fire({
  //         icon: "error",
  //         title: "Error",
  //         text: "Something went wrong while submitting the application.",
  //         confirmButtonColor: "#dc3545",
  //       });
  //     } finally {
  //       setLoading(false);
  //     }
  //   };

  const resetForm = () => {
    setFullName("");
    setEnrollmentNo("");
    setCourse("");
    setApplicationType("");

    setDuplicateFile(null);
    setIdProof(null);
    setOldDocument(null);
    setFirCopy(null);
    setPassportPhoto(null);
    setAuthorizationLetter(null);
    setRepresentativeId(null);

    setLostDocument(false);
    setAuthorization(false);
    setDeclaration(false);
    setProvisionalCertificate(null);

    setLatestMarksheet(null);

    setAllSemesterMarksheet(null);

    setFinalSemesterMarksheet(null);

    setProvisionalCopy(null);

    setLoading(false);
  };

  const applicationConfig = {
    duplicate_marksheet: {
      title: "Duplicate Marksheet",
      duplicateLabel: "Upload Duplicate Marksheet Application",
      oldDocumentLabel: "Old Marksheet",
      showLostOption: true,
      notes: [
        "All information provided in the application must be true and correct. Any false information may lead to rejection of the application.",
        "After approval, the Duplicate Marksheet will be issued within the prescribed time.",
      ],
    },

    migration_certificate: {
      title: "Migration Certificate",
      duplicateLabel: "Migration Certificate Application Form",
      oldDocumentLabel: "Attested Marksheet",
      showLostOption: false,
      notes: [
        "All information provided in the application must be true and correct. Any false information may lead to rejection of the application.",
        "After approval, the Migration Certificate will be issued within the prescribed time.",
      ],
    },

    provisional_degree: {
      title: "Provisional Degree",
      duplicateLabel: "Provisional Degree Application Form",
      oldDocumentLabel: "Final Year / Semester Marksheet",
      showLostOption: false,
      notes: [
        "All information provided in the application must be true and correct. Any false information may lead to rejection of the application.",
        "After approval, the Provisional Degree will be issued within the prescribed time.",
      ],
    },
  };

  return (
    <>
      <title>Various Application | ISBM University</title>

      <meta name="description" content="Various Application Form" />

      <Topnav />

      {/* Hero Section */}

      <section
        className="section-hero-banner ptb-50"
        style={{
          backgroundImage: `linear-gradient(rgba(28,36,71,0.8), rgba(28,36,71,0.8)), url(${faqBanner})`,
        }}
      >
        <div className="banner-hero-overlay">
          <div className="container-xxl">
            <div className="section-hero-content">
              <h1>Various Application</h1>
              <ol className="breadcrumb mt-3 text-center mb-0">
                <li className="breadcrumb-item">
                  <Link
                    to="/"
                    style={{ color: "#fff", textDecoration: "none" }}
                  >
                    Home
                  </Link>
                </li>
                <li
                  className="breadcrumb-item active text-white"
                  aria-current="page"
                >
                  Various Application
                </li>
                <hr className="section-divider" />
              </ol>
            </div>
          </div>
        </div>
      </section>
      {/* Intro Section */}

      <section className="bg-light py-5">
        <Container className="container-xxl">
          <Row className="align-items-center">
            <Col lg={6}>
              <div className="governing-image-wrapper shadow rounded overflow-hidden">
                <img
                  src={classroomImage}
                  alt="Various Application"
                  className="img-fluid"
                />
              </div>
            </Col>

            <Col lg={6}>
              <h2 className="modern-title text-blue">Various Application</h2>

              <div className="underline-divider mb-4"></div>

              <p className="text-muted">
                Students can apply online for duplicate certificates, duplicate
                marksheets, migration certificates, provisional certificates,
                transcripts, bonafide certificates and other university
                documents through this portal.
              </p>

              <p className="text-muted">
                Select your application type below and upload the required
                documents. Additional fields will automatically appear based on
                the selected application.
              </p>
            </Col>
          </Row>
        </Container>
      </section>

      {/* Form Section */}

      <section className="py-5">
        <Container className="container-xxl">
          <Card className="shadow border-0 rounded-4">
            <Card.Header
              className="text-white py-3"
              style={{ background: "#004E9E" }}
            >
              <h3 className="mb-0">Various Application Form</h3>
            </Card.Header>

            <Card.Body className="p-4">
              <Form onSubmit={handleSubmit}>
                {/* Applicant Details */}

                <h4 className="mb-4 text-purple">Applicant Details</h4>

                <Row>
                  <Col md={6} className="mb-3">
                    <Form.Group>
                      <Form.Label>Full Name</Form.Label>

                      <Form.Control
                        type="text"
                        placeholder="Enter Full Name"
                        value={fullName}
                        onChange={(e) => setFullName(e.target.value)}
                        required
                      />
                    </Form.Group>
                  </Col>

                  <Col md={6} className="mb-3">
                    <Form.Group>
                      <Form.Label>Enrollment Number</Form.Label>

                      <Form.Control
                        type="text"
                        placeholder="Enter Enrollment Number"
                        value={enrollmentNo}
                        onChange={(e) => setEnrollmentNo(e.target.value)}
                        required
                      />
                    </Form.Group>
                  </Col>

                  <Col md={6} className="mb-3">
                    <Form.Group>
                      <Form.Label>Course</Form.Label>
                      <Form.Control
                        type="text"
                        placeholder="Enter Course Name"
                        value={course}
                        onChange={(e) => setCourse(e.target.value)}
                        required
                      />
                    </Form.Group>
                  </Col>

                  <Col md={6} className="mb-3">
                    <Form.Group>
                      <Form.Label>Application Type</Form.Label>

                      <Form.Select
                        value={applicationType}
                        onChange={(e) => {
                          setApplicationType(e.target.value);
                          setLostDocument(false);
                          setAuthorization(false);
                        }}
                        required
                      >
                        <option value="">Select Application</option>

                        <option value="duplicate_marksheet">
                          Duplicate Marksheet
                        </option>

                        <option value="migration_certificate">
                          Migration Certificate
                        </option>

                        <option value="provisional_degree">
                          Provisional Degree
                        </option>
                      </Form.Select>
                    </Form.Group>
                  </Col>
                </Row>

                <hr className="my-4" />

                {/* ======================= Dynamic Documents ======================= */}

                {applicationType !== "" && (
                  <>
                    <h4 className="text-purple mb-4">Required Documents</h4>

                    <Row>
                      {/* Application Upload */}

                      <Col md={6} className="mb-3">
                        <Form.Group>
                          <Form.Label>
                            {applicationConfig[applicationType]?.duplicateLabel}
                          </Form.Label>

                          <Form.Control
                            type="file"
                            onChange={(e) =>
                              setDuplicateFile(e.target.files[0])
                            }
                            required
                          />
                        </Form.Group>
                      </Col>

                      {/* ID Proof */}

                      <Col md={6} className="mb-3">
                        <Form.Group>
                          <Form.Label>ID Proof (Aadhaar / PAN Card)</Form.Label>

                          <Form.Control
                            type="file"
                            onChange={(e) => setIdProof(e.target.files[0])}
                            required
                          />
                        </Form.Group>
                      </Col>

                      {/* Old Document */}

                      <Col md={6} className="mb-3">
                        <Form.Group>
                          <Form.Label>
                            {
                              applicationConfig[applicationType]
                                ?.oldDocumentLabel
                            }
                          </Form.Label>

                          <Form.Control
                            type="file"
                            disabled={lostDocument}
                            onChange={(e) => setOldDocument(e.target.files[0])}
                          />
                        </Form.Group>
                      </Col>

                      {/* Passport */}

                      <Col md={6} className="mb-3">
                        <Form.Group>
                          <Form.Label>Passport Size Photograph</Form.Label>

                          <Form.Control
                            type="file"
                            onChange={(e) =>
                              setPassportPhoto(e.target.files[0])
                            }
                            required
                          />
                        </Form.Group>
                      </Col>

                      {/* Lost Document */}

                      {applicationConfig[applicationType]?.showLostOption && (
                        <Col md={12} className="mb-3">
                          <Form.Check
                            type="checkbox"
                            className="mb-3"
                            label="I don't have the old document (Lost)"
                            checked={lostDocument}
                            onChange={(e) => setLostDocument(e.target.checked)}
                          />

                          {lostDocument && (
                            <Form.Group>
                              <Form.Label>
                                Upload FIR / Lost Certificate
                              </Form.Label>

                              <Form.Control
                                type="file"
                                onChange={(e) => setFirCopy(e.target.files[0])}
                                required
                              />
                            </Form.Group>
                          )}
                        </Col>
                      )}

                      {/* Migration Certificate */}

                      {applicationType === "migration_certificate" && (
                        <>
                          <Col md={6} className="mb-3">
                            <Form.Group>
                              <Form.Label>Provisional Certificate</Form.Label>

                              <Form.Control
                                type="file"
                                onChange={(e) =>
                                  setProvisionalCertificate(e.target.files[0])
                                }
                                required
                              />
                            </Form.Group>
                          </Col>

                          <Col md={6} className="mb-3">
                            <Form.Group>
                              <Form.Label>
                                Latest University Marksheet
                              </Form.Label>

                              <Form.Control
                                type="file"
                                onChange={(e) =>
                                  setLatestMarksheet(e.target.files[0])
                                }
                                required
                              />
                            </Form.Group>
                          </Col>
                        </>
                      )}

                      {/* Provisional Degree */}

                      {applicationType === "provisional_degree" && (
                        <>
                          <Col md={6} className="mb-3">
                            <Form.Group>
                              <Form.Label>All Semester Marksheets</Form.Label>

                              <Form.Control
                                type="file"
                                onChange={(e) =>
                                  setAllSemesterMarksheet(e.target.files[0])
                                }
                                required
                              />
                            </Form.Group>
                          </Col>

                          <Col md={6} className="mb-3">
                            <Form.Group>
                              <Form.Label>Final Semester Marksheet</Form.Label>

                              <Form.Control
                                type="file"
                                onChange={(e) =>
                                  setFinalSemesterMarksheet(e.target.files[0])
                                }
                                required
                              />
                            </Form.Group>
                          </Col>

                          <Col md={6} className="mb-3">
                            <Form.Group>
                              <Form.Label>
                                Provisional Certificate Copy
                              </Form.Label>

                              <Form.Control
                                type="file"
                                onChange={(e) =>
                                  setProvisionalCopy(e.target.files[0])
                                }
                                required
                              />
                            </Form.Group>
                          </Col>
                        </>
                      )}
                    </Row>

                    <hr className="my-4" />
                  </>
                )}

                {/* ======================= Authorization ======================= */}
                {applicationType !== "" && (
                  <>
                    <h4 className="text-purple mb-4">Authorization Details</h4>

                    <div className="border rounded-3 p-3 mb-4 bg-light">
                      <Form.Check
                        type="checkbox"
                        id="authorization"
                        checked={authorization}
                        onChange={(e) => setAuthorization(e.target.checked)}
                        label="I authorize another person to collect the document on my behalf."
                      />
                    </div>

                    {authorization && (
                      <Row>
                        <Col md={6} className="mb-3">
                          <Form.Group>
                            <Form.Label>Authorization Letter</Form.Label>

                            <Form.Control
                              type="file"
                              onChange={(e) =>
                                setAuthorizationLetter(e.target.files[0])
                              }
                              required
                            />

                            <small className="text-muted">
                              Upload signed authorization letter.
                            </small>
                          </Form.Group>
                        </Col>

                        <Col md={6} className="mb-3">
                          <Form.Group>
                            <Form.Label>Authorized Person ID Proof</Form.Label>

                            <Form.Control
                              type="file"
                              onChange={(e) =>
                                setRepresentativeId(e.target.files[0])
                              }
                              required
                            />

                            <small className="text-muted">
                              Aadhaar Card / PAN Card / Passport / Driving
                              Licence.
                            </small>
                          </Form.Group>
                        </Col>
                      </Row>
                    )}

                    <hr className="my-4" />
                  </>
                )}

                <div className="alert alert-warning">
                  <h6 className="fw-bold mb-3">Important Notes</h6>

                  <ol className="mb-3">
                    {applicationConfig[applicationType]?.notes?.map(
                      (note, index) => (
                        <li key={index} className="mb-2">
                          {note}
                        </li>
                      ),
                    )}
                  </ol>

                  <p className="fw-bold mb-1">Download Application Form</p>

                  <a
                    href="https://isbmuniversity.edu.in/download-form"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    https://isbmuniversity.edu.in/download-form
                  </a>
                </div>

                {/* ======================= Declaration ======================= */}

                <div className="border rounded-3 p-4 bg-light mt-4">
                  <h5 className="text-blue fw-bold mb-3">Declaration</h5>

                  <Form.Check
                    type="checkbox"
                    id="declaration"
                    checked={declaration}
                    onChange={(e) => setDeclaration(e.target.checked)}
                    required
                    label="I hereby declare that all the information furnished by me is true and correct. I understand that if any information is found to be false or misleading, my application may be rejected by ISBM University."
                  />
                </div>

                {/* ======================= Submit Buttons ======================= */}

                <div className="text-center mt-5">
                  <Button
                    type="submit"
                    variant="blue"
                    className="px-5 me-3 btn-blue"
                    disabled={!declaration || loading}
                  >
                    {loading ? (
                      <>
                        <span
                          className="spinner-border spinner-border-sm me-2"
                          role="status"
                        ></span>
                        Submitting...
                      </>
                    ) : (
                      <>
                        <i className="ti ti-send me-2"></i>
                        Submit Application
                      </>
                    )}
                  </Button>

                  <Button
                    type="button"
                    variant="outline-purple"
                    className="px-5 btn-outline-purple"
                    onClick={resetForm}
                  >
                    <i className="ti ti-rotate-clockwise me-2"></i>
                    Reset Form
                  </Button>
                </div>
              </Form>
            </Card.Body>
          </Card>
        </Container>
      </section>
      <button
        type="button"
        id="paymentModalBtn"
        className="d-none"
        data-bs-toggle="modal"
        data-bs-target="#paymentModal"
      ></button>
      {/* ================= Payment Modal ================= */}

      <div
        className="modal fade"
        id="paymentModal"
        tabIndex="-1"
        aria-labelledby="paymentModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content border-0 shadow-lg">
            <div
              className="modal-header text-white"
              style={{ background: "#004E9E" }}
            >
              <h5 className="modal-title">Select Payment Method</h5>

              <button
                type="button"
                className="btn-close btn-close-white"
                data-bs-dismiss="modal"
              ></button>
            </div>

            <div className="modal-body p-4">
              <p className="text-center mb-4">
                Choose your preferred payment gateway
              </p>

              <div className="row g-4">
                {/* Razorpay */}

                <div className="col-md-6">
                  <div
                    className="border rounded p-3 text-center h-100"
                    style={{
                      cursor: "pointer",
                      transition: ".3s",
                    }}
                    onClick={() => {
                      document.getElementById("paymentModalCloseBtn")?.click();

                      handleRazorpay(pendingFormData);
                    }}
                  >
                    <img
                      src={razorpay}
                      alt="Razorpay"
                      className="img-fluid mb-3"
                      style={{
                        height: 70,
                        objectFit: "contain",
                      }}
                    />

                    <h5>Razorpay</h5>

                    <small className="text-muted">
                      UPI, Cards, Net Banking, Wallet
                    </small>
                  </div>
                </div>

                {/* BasisPay */}

                <div className="col-md-6">
                  <div
                    className="border rounded p-3 text-center h-100"
                    style={{
                      cursor: "pointer",
                      transition: ".3s",
                    }}
                    onClick={() => {
                      document.getElementById("paymentModalCloseBtn")?.click();

                      handleBasisPay(pendingFormData);
                    }}
                  >
                    <img
                      src={basispay}
                      alt="BasisPay"
                      className="img-fluid mb-3"
                      style={{
                        height: 70,
                        objectFit: "contain",
                      }}
                    />

                    <h5>BasisPay</h5>

                    <small className="text-muted">BasisPay Gateway</small>
                  </div>
                </div>
              </div>

              <div className="text-center mt-4">
                <small className="text-muted">
                  <i className="ti ti-lock me-1"></i>
                  Secure SSL Encrypted Payment
                </small>
              </div>

              <button
                id="paymentModalCloseBtn"
                className="d-none"
                data-bs-dismiss="modal"
              ></button>
            </div>
          </div>
        </div>
      </div>

      <Footer />
    </>
  );
};

export default VariousApplication;
